import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, mergeMap, map, exhaustMap, tap } from 'rxjs/operators';

import { of } from 'rxjs';
import {
    fetchRecords,
    fetchRecordsSuccess,
    fetchRecordsFail,
    markNotification,
    markNotificationSuccess,
    markNotificationFail
} from './dashboard.action';
import { AlertService } from 'src/app/core/services/alert.service';
import { CrudServerService } from 'src/app/core/services/crud-server.service';
import { RouterService } from 'src/app/core/services/router.service';
import { Store } from '@ngrx/store';
import { RootReducerState } from '..';
import { DatatableService } from 'src/app/core/services/datatable.service';
import { getPaymentSuccess } from '../PaymentGateway/payment-gateway.action';

@Injectable()
export class DashboardRecordEffects {

    fetchData$ = createEffect(() =>
        this.actions$.pipe(
            ofType(fetchRecords),
            exhaustMap((data) => {
                const url = 'client-dashboard?year='+data.year;
                return this.crudServerService.fetchData(url).pipe(
                    map( (response) => {
                        const data = response.data;
                        this.alertService.triggerAlert(response.message, "success");
                        this.store.dispatch(getPaymentSuccess({hasConnect: response.data.hasConnect, hasManualConnect: response.data.hasManualConnect}));
                        return fetchRecordsSuccess({listData: data});
                    }),
                    
                    catchError((error) =>
                        of(error).pipe(
                            tap(() => {
                                this.alertService.triggerAlert(error, "error");
                            }),
                            map(() => fetchRecordsFail({ error })) // Dispatch 
                        )
                    )
                )
            })
        )
    );

    markNotification$ = createEffect(() =>
        this.actions$.pipe(
            ofType(markNotification),
            exhaustMap(() => {
                const url = 'delete-notification';
                return this.crudServerService.fetchData(url).pipe(
                    map( (response) => {
                        this.alertService.triggerAlert(response.message, "success");
                        return markNotificationSuccess();
                    }),
                    
                    catchError((error) =>
                        of(error).pipe(
                            map(() => markNotificationFail({ error })) 
                        )
                    )
                )
            })
        )
    );

    constructor(
        private actions$: Actions,
        private crudServerService: CrudServerService,
        private alertService: AlertService,
        private routeService: RouterService,
        private store: Store<RootReducerState>,
        private tableService: DatatableService
    ) { }

}